import { graphql, useStaticQuery } from 'gatsby';
import React, { useContext } from 'react';
import AppContext from '../context';
import {
  PersonalInfoWrapper,
  OuterPersonalInfoWrapper,
  SideBarWrapper,
} from '../elements';

export const PersonalInfo = () => {
  const data = useStaticQuery(graphql`
    query {
      web: file(relativePath: { eq: "web.png" }) {
        publicURL
      }
      coding: file(relativePath: { eq: "coding.png" }) {
        publicURL
      }
    }
  `);
  const { dark } = useContext(AppContext);
  return (
    <OuterPersonalInfoWrapper dark={dark}>
      <SideBarWrapper />
      <PersonalInfoWrapper>
        <h1>Anish Koulgi</h1>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className='info-container'
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <h2 style={{ paddingLeft: 0 }}>Web Developer </h2>{' '}
            <img src={data.web.publicURL} alt='WEB' />
          </div>
          <p style={{ paddingBottom: '-5px' }}>|</p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <h2 style={{ paddingLeft: 0 }}>Competitive Programmer</h2>
            <img src={data.coding.publicURL} alt='CP' />
          </div>
        </div>
      </PersonalInfoWrapper>
      <SideBarWrapper />
    </OuterPersonalInfoWrapper>
  );
};
